var _circle, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDataModeOld = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "url(#paint0_linear_13997_56766)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.6848 6.68078C10.7543 6.7179 9.95906 6.85044 9.23269 7.08903C8.88277 7.20567 8.40295 7.45221 8.23063 7.60597C8.05567 7.76502 8 7.85516 8 7.99036C8 8.1229 8.05302 8.21304 8.22003 8.36414C8.68925 8.79094 9.72047 9.12231 11.03 9.26812C11.5284 9.32114 12.7929 9.32909 13.2621 9.27872C14.5744 9.14087 15.5473 8.85457 16.1066 8.44367C16.2948 8.30582 16.43 8.11495 16.43 7.99036C16.43 7.94264 16.3956 7.85516 16.3505 7.78623C15.9873 7.23748 14.4471 6.74971 12.8937 6.69139C12.6869 6.68343 12.4377 6.67283 12.3343 6.67018C12.2336 6.66488 11.9393 6.67018 11.6848 6.68078Z",
  fill: "white"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 10.1853V11.2006L8.07688 11.3226C8.23063 11.5638 8.66804 11.8157 9.28306 12.0198C11.2103 12.6587 14.2642 12.5394 15.7673 11.7653C16.0457 11.6248 16.3187 11.4021 16.3929 11.2616C16.4221 11.2006 16.43 11.0045 16.43 10.1774C16.43 9.62332 16.4247 9.17001 16.4194 9.17001C16.4141 9.17001 16.3267 9.21773 16.2259 9.2734C15.9794 9.41655 15.5128 9.60211 15.1364 9.7108C12.9228 10.3497 9.86892 10.1668 8.24654 9.30256L8 9.17001V10.1853Z",
  fill: "white"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M8 13.3138V14.3291L8.07688 14.451C8.33932 14.8619 9.3838 15.2755 10.6112 15.4505C11.714 15.6095 13.1004 15.5883 14.1502 15.3974C15.0648 15.2331 15.8309 14.9388 16.1888 14.6128C16.4406 14.3874 16.43 14.4404 16.43 13.2952C16.43 12.6802 16.4194 12.2985 16.4035 12.2985C16.3903 12.2985 16.3161 12.3356 16.2392 12.3806C15.656 12.7253 14.6751 12.9983 13.5272 13.1362C13.0289 13.1971 11.5311 13.2051 11.0353 13.1521C9.85567 13.0248 8.88012 12.765 8.22003 12.4019C8.11399 12.3462 8.02121 12.2985 8.01325 12.2985C8.0053 12.2985 8 12.7544 8 13.3138Z",
  fill: "white"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M8 16.4309V17.4594L8.07953 17.5681C8.37113 17.9737 9.31487 18.3608 10.4389 18.5384C11.1202 18.6471 11.9446 18.6895 12.7187 18.6577C13.9647 18.6046 14.9482 18.4005 15.701 18.0373C16.0404 17.8703 16.2657 17.7007 16.3611 17.539L16.43 17.4223L16.4247 16.415L16.4168 15.4049L16.2445 15.503C15.7302 15.7946 14.9269 16.0518 14.1237 16.179C13.0448 16.354 11.7697 16.3725 10.6642 16.232C9.72842 16.1154 8.74492 15.8291 8.19617 15.5163L8 15.4049V16.4309Z",
  fill: "white"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_13997_56766",
  x1: 6.5,
  y1: 1,
  x2: 16,
  y2: 23,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1EAED"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A0C8FF"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDataModeOld);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/data_mode_old.5b8dfdb270a3fc80886ab2adc93c0b77.svg";